/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getUser } from "../../../apis/auth";
import SignUpCompleteImg from "../../../assets/images/sign-up-complete.png"
import { getCompnayNum } from "../../../utils/storage";
const SignUpComplete = (props) => {

  const [comNum, setCompnayNum] = useState(null);
  useEffect(() => {
    setCompnayNum(getCompnayNum())
  }, [])
  const history = useHistory();

  const user = getUser();

  const goSearchCompnay = () => {
    history.push('/join-company')
  }
  const goCreateCompnay = () => {
    history.push('/create-company')
  }

  return (
    <div className="Layout auth-wrap">
      <div className="sign-up sign-up-complete">
        <div className="sign-up-complete-box">
          <div className="img">
            <img src={SignUpCompleteImg} />
          </div>
          <p>
            {user?.name || ''}님 축하합니다. <br />
            회원가입이 완료되었습니다.
          </p>
          {comNum && <>
            <button onClick={goSearchCompnay} className="sign-up-btn" >
              직원등록 요청
            </button>
          </>}
          {!comNum &&
            <>
              <button onClick={goSearchCompnay} className="sign-up-btn" >
                회사검색
              </button>
              <button onClick={goCreateCompnay} className="sign-up-btn2" >
                신규 기업 등록
              </button>
            </>

          }
        </div>
      </div>
    </div>
  );
};

export default SignUpComplete;
